export const imageSvgs = {
  success: 'https://www.postnord.se/contentassets/5fe2c739644149e79d73c1082e575af3/success.svg'
}

export const imageUrls = {
  mobileIllustration: 'https://se-prep.postnord.com/siteassets/images-new/app-images/track-swe.webp',
};

export const appImages = {
  postnordAppStore: 'https://se-prep.postnord.com/siteassets/startpage-blocks/AppStore-transparent.svg',
  postnordGooglePlay: 'https://se-prep.postnord.com/siteassets/startpage-blocks/googleplay-transparent.svg',
};
